import React from "react";
import { DataTable } from "./DataTable";
import { Button, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { useInAndOutModel } from "../inAndOutModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { importPropsConfig } from "@/utils/importFile";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { formatNum } from "@/utils/utils";
export const DataBox = () => {
    const { selectedRowKeys, descTotal, rowsDescTotal } = useInAndOutModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const desc: IDescription[] = [
        {
            // label: "出库数量",
            label: Locale["Stock-out Qty"],
            value: selectedRowKeys.length === 0 ? descTotal.outNum : formatNum(rowsDescTotal.outNum),
            color: DescriptionColorEnum.red
        },
        {
            // label: "出库金额",
            label: Locale["Stock-out Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.outAomunt : formatNum(rowsDescTotal.outAomunt),
            color: DescriptionColorEnum.red
        },
        {
            // label: "入库数量",
            label: Locale["Stock-in Qty"],
            value: selectedRowKeys.length === 0 ? descTotal.ioNum : formatNum(rowsDescTotal.ioNum),
            color: DescriptionColorEnum.red
        },
        {
            // label: "入库金额",
            label: Locale["Stock-in Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.ioAomunt : formatNum(rowsDescTotal.ioAomunt),
            color: DescriptionColorEnum.red
        }
    ]
    return (
        <YhBox title={<></>} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}